import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './verify_email.css';

import firebase from "../../firebase/FirebaseProvider";
import { isUserAnonymous, isUserVerified } from '../../util/user_util'
import getConfig from '../../config';
import axios from 'axios';

class EmailNotVerifiedMessage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emailSent: false,
            user : null
        };

        this.handleSendEmailVerification = this.handleSendEmailVerification.bind(this);
    }

    handleSendEmailVerification(e) {
        e.preventDefault();
        const config = getConfig();
        let user = firebase.auth().currentUser;
        const url = config.daisy.domain + config.daisy.services.send_verify_email;
        const data = { "displayName": user.displayName, "email": user.email };
        console.log("Email Verification Url:", url);
        console.log("Email Verification Data:", data);
        ReactGA.event({
            category: 'Login',
            action: 'Send Email',
            label: data
        });
        axios.post(
            url,
            data
        ).then(resp => {
            this.setState({ emailSent: true });
            console.log('Email sent');
        }).catch(err => {console.log(err);
            const errorMsg = JSON.stringify(err);
            ReactGA.event({
                category: 'Login',
                action: 'Send Email Error',
                label: errorMsg
            });
        });
    }

    render() {
        const { user } = this.props;
        this.state.user = user;
        const isAnonymousUser = isUserAnonymous(user);
        const isVerified = isUserVerified(user);
        return (
            <div>
                {!isVerified && !isAnonymousUser && <div className="banner" >
                    {
                        !this.state.emailSent ? 
                                (<div className="banner description">Please verify your email to start discussion. Didn't get email? <a onClick={this.handleSendEmailVerification}>
                                    Resend Email</a>
                                </div>)
                            : (<div className="banner description">Email Sent. Please check your email and verify account.</div>)
                    }

                </div>}
            </div>
        );
    }
}

EmailNotVerifiedMessage.propTypes = {
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailNotVerifiedMessage);